import { create } from 'zustand';

export const useNotificationStore = create((set) => ({
    // --- État pour le Dialog global ---
    isOpen: false,
    type: 'success',
    title: '',
    message: '',
    show: (config) => set({
        isOpen: true,
        type: config.type || 'success',
        title: config.title || '',
        message: config.message || '',
    }),
    hide: () => set({ isOpen: false }),

    notifications: [],
    unreadCount: 0,

    addNotification: (notif) => set((state) => ({
        notifications: [
            {
                id: Date.now().toString(),
                read: false,
                time: "À l'instant",
                ...notif
            },
            ...state.notifications
        ].slice(0, 30),
        unreadCount: state.unreadCount + 1
    })),

    markAsRead: (id) => set((state) => ({
        notifications: state.notifications.map(n => n.id === id ? { ...n, read: true } : n),
        unreadCount: Math.max(0, state.unreadCount - 1)
    })),

    markAllRead: () => set((state) => ({
        notifications: state.notifications.map(n => ({ ...n, read: true })),
        unreadCount: 0
    })),

    deleteNotif: (id) => set((state) => {
        const notifToDelete = state.notifications.find(n => n.id === id);
        return {
            notifications: state.notifications.filter(n => n.id !== id),
            unreadCount: (notifToDelete && !notifToDelete.read) ? state.unreadCount - 1 : state.unreadCount
        };
    })
}));